import * as React from 'react'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { API, ComplianceReportRequestWithStoreInfo } from '@getgreenline/homi-shared'
import { FormError } from '../../../../../components/FormError'
import { ComplianceStore } from '../ComplianceStore'
import { Button } from 'antd'
import { Track } from '../../../../../Track'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  site: string
  city: string
  companyName: string
  postalCode: string
  administrativeEmployees: number
  managementEmployees: number
  salesEmployees: number
  productionEmployees: number
  otherEmployees: number
  isLoading: boolean
  errorMessage?: string
}

export class Nunavut extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      site: '',
      city: '',
      companyName: '',
      postalCode: '',
      administrativeEmployees: 0,
      managementEmployees: 0,
      salesEmployees: 0,
      productionEmployees: 0,
      otherEmployees: 0,
      isLoading: false,
    }
  }

  generate() {
    const { month, year, locationIds } = this.props.complianceStore
    const {
      companyName,
      postalCode,
      site,
      city,
      managementEmployees,
      administrativeEmployees,
      salesEmployees,
      productionEmployees,
      otherEmployees,
    } = this.state

    const params: ComplianceReportRequestWithStoreInfo = {
      month,
      year,
      companyName,
      postalCode,
      site,
      city,
      numberOfManagementEmployees: managementEmployees,
      numberOfAdministrativeEmployees: administrativeEmployees,
      numberOfSalesEmployees: salesEmployees,
      numberOfProductionEmployees: productionEmployees,
      numberOfOtherEmployees: otherEmployees,
      locationIds,
    }

    Track.track('dashboard:compliance_complianceReportGenerated', params)
    const company = this.props.currentCompanyStore!.company!
    this.setState({
      isLoading: true,
      errorMessage: undefined,
    })

    API.getComplianceReport(company.id, 'NU', params)
      .then((response) => {
        this.setState({ isLoading: false })

        const blob = new Blob([response])
        const a = window.document.createElement('a')
        a.href = (window.URL as any).createObjectURL(blob, { type: 'text/plain' } as any)
        a.download = this.props.complianceStore.generateFileName(company.name, 'csv')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          errorMessage: error.response.data.message,
        })
      })
  }

  render() {
    const {
      isLoading,
      errorMessage,
      site,
      city,
      companyName,
      postalCode,
      managementEmployees,
      administrativeEmployees,
      salesEmployees,
      productionEmployees,
      otherEmployees,
    } = this.state
    const { month, year, locationIds } = this.props.complianceStore

    return (
      <div>
        <div>
          <div className='form-group'>
            <label>Company Name</label>
            <input
              className='form-control'
              value={companyName}
              onChange={(e) => this.setState({ companyName: e.target.value })}
            />
          </div>
          <div className='form-group'>
            <label>Site (NU#####-##)</label>
            <input
              className='form-control'
              value={site}
              onChange={(e) => this.setState({ site: e.target.value })}
            />
          </div>
          <div className='form-group'>
            <label>City</label>
            <input
              className='form-control'
              value={city}
              onChange={(e) => this.setState({ city: e.target.value })}
            />
          </div>
          <div className='form-group'>
            <label>Postal Code</label>
            <input
              className='form-control'
              value={postalCode}
              onChange={(e) => this.setState({ postalCode: e.target.value })}
            />
          </div>
          <br />

          <div className='row form-group'>
            <div className='col-md-6'>Management employees</div>
            <div className='col-md-6'>
              <input
                type='number'
                className='form-control'
                value={managementEmployees}
                onChange={(e) => this.setState({ managementEmployees: parseInt(e.target.value) })}
              />
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-md-6'>Administrative employees</div>
            <div className='col-md-6'>
              <input
                type='number'
                className='form-control'
                value={administrativeEmployees}
                onChange={(e) =>
                  this.setState({ administrativeEmployees: parseInt(e.target.value) })
                }
              />
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-md-6'>Sales employees</div>
            <div className='col-md-6'>
              <input
                type='number'
                className='form-control'
                value={salesEmployees}
                onChange={(e) => this.setState({ salesEmployees: parseInt(e.target.value) })}
              />
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-md-6'>Production employees</div>
            <div className='col-md-6'>
              <input
                type='number'
                className='form-control'
                value={productionEmployees}
                onChange={(e) => this.setState({ productionEmployees: parseInt(e.target.value) })}
              />
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-md-6'>Other employees</div>
            <div className='col-md-6'>
              <input
                type='number'
                className='form-control'
                value={otherEmployees}
                onChange={(e) => this.setState({ otherEmployees: parseInt(e.target.value) })}
              />
            </div>
          </div>
          <br />
          <div>
            <Button
              type='primary'
              onClick={() => this.generate()}
              loading={locationIds.length === 0 || isLoading}
            >
              {isLoading ? 'Downloading...' : 'Download report'}
            </Button>
          </div>
          <FormError message={errorMessage} />
        </div>
      </div>
    )
  }
}
